//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		data: {
			type: Array
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isSwiperInit: false,
			swiperOption: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				mousewheelControl: true,
				observer: true,
				observeParents: true,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				onInit(swiper) {
					if (swiper.virtualSize == swiper.width) {
						swiper.nextButton[0].style.display = 'none'
						swiper.prevButton[0].style.display = 'none'
					}
				},
				onAfterResize(swiper) {
					if (swiper.virtualSize == swiper.width) {
						swiper.nextButton[0].style.display = 'none'
						swiper.prevButton[0].style.display = 'none'
					} else {
						swiper.nextButton[0].style.display = 'block'
						swiper.prevButton[0].style.display = 'block'
					}
				}
			}
		}
	},
	methods: {
		toInfo(cpfl, type, code) {
			if (type == '2') {
				this.$router.push({
					path: '/finadetail/' + code
				})
			} else if (type == '1') {
				this.$router.push({
					path: '/funddetail/' + code
				})
			}
		},
		goRouter(cpfl, type, code) {
			if (type == '2') {
				if (cpfl && cpfl == this.constants.ES_TYCPFL.OTC && this.checkLogin != true) {
					this.goLogin('/login', '/finadetail/' + code)
				} else {
					this.$router.push({
						path: '/finadetail/' + code
					})
				}
			} else if (type == '1') {
				this.$router.push({
					path: '/funddetail/' + code
				})
			}
		}
	},
	filters: {
		addunit(value, unit) {
			if (value.indexOf('或') > -1) {
				return value.replace('或', unit + ' 或 ') + unit
			} else if (value.indexOf('~') > -1) {
				return value.replace('~', unit + ' ~ ') + unit
			} else if (value == '') {
				return '--'
			} else {
				return value + unit
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/newprobanner.vue